import * as get from 'lodash/get';

import { SeriesMapper } from './series-mapper.interface';

/**
 * FilterMapper is used to add filter to mapper, so that when we want to get data out of state
 * and filter them based on condition, we can pass a filter call back function, then it will filter data first
 * then return the result data.
 */
export class FilterMapper implements SeriesMapper {
	constructor(public readonly storeDependencies: string[], public readonly expression: string, public readonly callbackForFilter: Function) { }
	public getStoreDependencies(): string[] {
		return this.storeDependencies;
	}
	public mapper(...storeData: any[]): any[] {
		return get(storeData[0], this.expression, [])
			.filter(this.callbackForFilter);
	}
}
